
import React from "react";
// import FloaterDialog from "root/FloaterDialog";

const PanelWrapper = ({ title, help_text, children }) =>
{
    const floaterDialog = (help_text) =>
    {
        if (help_text != null)
        {
            return (
                { /* <FloaterDialog text={help_text} delay={1} icon="et-info-with-circle" color="var(--s360-icon-blue)"/> */ }
            );
        }
    }

    return (
        <div>
            <div className="panel-heading panel-heading-adulthood"><span>{title}</span>
                {floaterDialog(help_text)}
            </div>

            <div className="panel-body panel-body-adulthood">
                {children}
            </div>
        </div>
    )
}
export default PanelWrapper;